module.exports = __webpack_public_path__ + "img/img-5.6fc80c9b.jpg";